/** Created by azhou on 2019/2/26.*/
<template>
  <div class="d-center-around">
    <rectangle-comp bgColor="#85B0E1" nones='1' class="cursor-pointer"><!--@click.native="$router.push({name:'OrderPost',query:{type:'住宿订单'}})"-->
      <h4>我的订单</h4>
      <p class="text-left" v-if="userInfo.type===2" @click="$emit('OrderHandle',userInfo.type,'0')">
        待&ensp;处&ensp;理<span :class="{'text-danger':IndexData.order_arr.wait_handle>0}"> {{IndexData.order_arr.wait_handle}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===2" @click="$emit('goOrderLists',userInfo.type,'7')">
        待&ensp;入&ensp;住<span :class="{'text-danger':IndexData.order_arr.status_4>0}"> {{IndexData.order_arr.status_7}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===2" @click="$emit('goOrderLists',userInfo.type,'today')">
        今日入住<span :class="{'text-danger':IndexData.order_arr.status_today>0}"> {{IndexData.order_arr.status_today}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===2" @click="$emit('goOrderLists',userInfo.type,'stay')">
        入&ensp;住&ensp;中<span :class="{'text-danger':IndexData.order_arr.status_stay>0}"> {{IndexData.order_arr.status_stay}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===2" @click="$emit('goOrderLists',userInfo.type,'all','2')">
        未&ensp;支&ensp;付<span :class="{'text-danger':IndexData.order_arr.wait_pay>0}"> {{IndexData.order_arr.wait_pay}}</span> 个
      </p>
    </rectangle-comp>
      <rectangle-comp bgColor="#80C9CE" nones='1'>
      <h4>发布订单</h4>
      <p>当前用户共发布<span> {{IndexData.send_order_arr.send_count}}</span> 个</p>
      <p>所属采购商共发布<span> {{IndexData.send_order_arr.send_store_count}}</span> 个</p>
    </rectangle-comp>
    <!-- <rectangle-comp bgColor="#80C9CE" nones='1'>
      <h4>订单管理</h4>
      <p @click="$emit('goOrderLists',3)">住宿订单：<span>{{IndexData.hOrderNum}}</span> 个</p>
      <p @click="$emit('goOrderLists',5)">民宿订单：<span>{{IndexData.hsOrderNum}}</span> 个</p>
      <p @click="$emit('goOrderLists',6)">景区订单：<span>{{IndexData.vpOrderNum}}</span> 个</p>
    </rectangle-comp> -->
    <rectangle-comp bgColor="#F8C26A" nones='1'>
      <h4>人事管理</h4>
      <p @click="$router.push({name:'PositionManage'})">职位数量 <span>{{IndexData.position_arr.position_count}}</span> 个</p>
      <p @click="$router.push({name:'StaffManage'})">人员数量 <span>{{IndexData.position_arr.user_count}}</span> 个</p>
    </rectangle-comp>
    <!-- <rectangle-comp bgColor="#b8a6d8">
      <h4>收藏管理</h4>
      <p @click="$router.push({name:'CollectManage',query:{type:3}})">已收藏 <span>{{IndexData.favHotelCount}}</span> 家酒店</p>
      <p @click="$router.push({name:'CollectManage',query:{type:5}})">已收藏 <span>{{IndexData.favHomestayCount}}</span> 家民宿</p>
      <p @click="$router.push({name:'CollectManage',query:{type:6}})">已收藏 <span>{{IndexData.favViewpointCount}}</span> 家景区</p>
    </rectangle-comp> -->
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RectangleComp from './RectangleComp'

  export default {
    name: 'TCenter',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['storeInfo','userInfo'])
    },
    components: { RectangleComp },
  }
</script>
